import './../style.scss'
export default {
    computed: {
        // 销毁单状态
        statusList () {
            return [{
                label: '草稿',
                value: 0,
                theme: 'normal'
            }, {
                label: '已确认',
                value: 1,
                theme: 'primary'
            }, {
                label: '已取消',
                value: 10,
                theme: 'error'
            }]
        },
        // 销毁单操作类型
        operateTypeList () {
            return [{
                label: '创建',
                value: 0
            }, {
                label: '保存',
                value: 1,
            }, {
                label: '确认',
                value: 5
            }, {
                label: '取消',
                value: 10
            }]
        }
    }
}